"use client"

import type React from "react"

interface StatisticsCardProps {
  title: string
  used: number
  total: number
  icon: string
  color: "blue" | "red" | "green" | "purple" | "amber"
}

const StatisticsCard: React.FC<StatisticsCardProps> = ({ title, used, total, icon, color }) => {
  const percentage = Math.round((used / total) * 100)

  const colorClasses = {
    blue: {
      bg: "bg-blue-500",
      text: "text-blue-600 dark:text-blue-400",
      light: "bg-blue-100 dark:bg-blue-900/30",
    },
    red: {
      bg: "bg-red-500",
      text: "text-red-600 dark:text-red-400",
      light: "bg-red-100 dark:bg-red-900/30",
    },
    green: {
      bg: "bg-green-500",
      text: "text-green-600 dark:text-green-400",
      light: "bg-green-100 dark:bg-green-900/30",
    },
    purple: {
      bg: "bg-purple-500",
      text: "text-purple-600 dark:text-purple-400",
      light: "bg-purple-100 dark:bg-purple-900/30",
    },
    amber: {
      bg: "bg-amber-500",
      text: "text-amber-600 dark:text-amber-400",
      light: "bg-amber-100 dark:bg-amber-900/30",
    },
  }

  return (
    <div className="bg-white dark:bg-navy-800 rounded-xl shadow-md overflow-hidden">
      <div className="p-5">
        <div className="flex items-center mb-3">
          <div className={`p-2 rounded-lg ${colorClasses[color].light} mr-3`}>
            <i className={`fas fa-${icon} ${colorClasses[color].text} text-lg`}></i>
          </div>
          <h3 className="font-semibold text-gray-800 dark:text-white">{title}</h3>
        </div>

        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-gray-500 dark:text-gray-400">
            Used: {used} of {total} days
          </span>
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{percentage}%</span>
        </div>

        <div className="w-full bg-gray-200 dark:bg-navy-600 rounded-full h-2">
          <div className={`${colorClasses[color].bg} h-2 rounded-full`} style={{ width: `${percentage}%` }}></div>
        </div>
      </div>
    </div>
  )
}

export default StatisticsCard
